<template>
    <div :style="`color: ${color}`" :class="light ? 'text-xs' : 'text-sm'">
        <slot />
    </div>
</template>

<script setup>
import tailwind from '@/lib/tailwind'

const props = defineProps({
    light: { type: Boolean, default: false },
    color: { type: String, default: tailwind.theme.color.text.darker },
})
</script>
